export default __webpack_public_path__ + "static/media/lampas4-min.d283de2e.jpg";